import { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import { logCustomEvent } from '../../reportWebVitals';
 

const TrackSectionStickiness = ({ sectionName }) => {
  const startTimeRef = useRef(null);

  useEffect(() => {
    // Record start time when the component mounts or section is viewed
    startTimeRef.current = Date.now();

    // Function to log time spent when the component unmounts or user leaves
    const logTimeSpent = () => {
      const endTime = Date.now();
      const timeSpent = Math.round((endTime - startTimeRef.current) / 1000); // Time in seconds

      console.log(`Time spent in ${sectionName}: ${timeSpent} seconds`);
      // Log custom event to Google Analytics
      logCustomEvent(sectionName + 'time_spent', {
        category: 'Stickiness',
        label: sectionName,
        value: timeSpent, // Time spent in seconds
        nonInteraction: true, // Non-interaction event to avoid affecting bounce rate
      });
    };

    // Add event listener for visibility change or component unmount
    const handleVisibilityChange = () => {
      if (document.hidden) {
        logTimeSpent();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      logTimeSpent(); // Log time when component unmounts
    };
  }, [sectionName]);

  return null; // This is a utility component, no UI needed
};

export default TrackSectionStickiness;